import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const getContentAccessControlEditPermissionsDisabledTooltipI18nKey = contentType => `contentAccessControl.disabledTooltip.${contentType}`;
export const getHasNoAccessGroupsSelectedTooltipFormattedMessage = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "contentAccessControl.accessGroupsSelect.errors.noAccessGroupsSelected"
});
export const getAccessGroupsUsageLimitReachedTooltipFormattedMessage = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "accessGroups.disabledTooltip.limitReached"
});